import { render, staticRenderFns } from "./StoreArchSit.vue?vue&type=template&id=02812b29&scoped=true"
import script from "./StoreArchSit.vue?vue&type=script&lang=js"
export * from "./StoreArchSit.vue?vue&type=script&lang=js"
import style0 from "./StoreArchSit.vue?vue&type=style&index=0&id=02812b29&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02812b29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02812b29')) {
      api.createRecord('02812b29', component.options)
    } else {
      api.reload('02812b29', component.options)
    }
    module.hot.accept("./StoreArchSit.vue?vue&type=template&id=02812b29&scoped=true", function () {
      api.rerender('02812b29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeDetails/components/StoreArchSit.vue"
export default component.exports